import xhr from '../utils/fetch';

const createRegistration = async (data: any) => {
  return await xhr({
    url: '/registrations',
    method: 'POST',
    body: data
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

export const registrationApi = {
  createRegistration
};
